import { Route, Routes } from 'react-router';
import Main from './layouts/Main/Main';
import Question from './layouts/Question/Question';
import Services from './layouts/Services/Services';

export default function AppRoutes() {
  return (
    <Routes>
      <Route index element={<Main />} />
      <Route path="/services" element={<Services />} />
      <Route path="/question" element={<Question />} />
    </Routes>
  );
}
